
	// @ts-nocheck  (визард собирается, а юарм - нет, и наоборот. Надо что-то делать)
	import ctrlMixins from './_mixins.js'
	import numberinput from './number_input.vue'
	/** Двойной контрол "числовое поле" для фильтрации по диапазону, см. getFilterControlComponent в p_list.vue */

	export default {
		name: 'number_input_double',
		mixins: [ctrlMixins], // c_value, c_ctrlParams, c_srv_options, пропсы view_type, field_meta и так далее
		meta: {

		},
		props: { // большая часть пропсов приезжает из ctrlMixins!
			value: {
				default: function(){
					return ['','']
				}
			},
		},
		data: function(){
			var propsWithoutValue = Object.assign({ is_double: true, }, this.$props);
			delete propsWithoutValue.value;
			return {
				propsWithoutValue
			}
		},
		computed: {},
		components: {
			numberinput
		},
		methods: {
			onUpdate: function(index, newVal){
				var valueArray = [];
				valueArray[index] = newVal;
				var anotherIndex = index ? 0 : 1;
				valueArray[anotherIndex] = this.$props.value[anotherIndex];
				this.$emit('update:value', valueArray);
			},
		}
	}
